import axios from 'axios'
import { CANCELAR_MDFE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cancelarMdfe(emissaoMdfeId, empresaId, justificativa) {
  const url = `${URL}/evento-mdfe/${emissaoMdfeId}/empresa/${empresaId}/cancelar`;
  return dispatch => axios.post(url, { justificativa }, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CANCELAR_MDFE,
        payload: response
      })
  );
}
